import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-small",
  "use": "arrow-small-usage",
  "viewBox": "0 0 12 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 14\" id=\"arrow-small\"><path d=\"M4.952 0h2.096v8.53c0 1.025-.186 2.142-.512 2.748l.163.093c.305-.57.61-1.016 1.041-1.43l2.84-2.66L12 8.816l-5.814 5.185h-.349L0 8.817 1.42 7.28l2.647 2.484c.536.466.885.955 1.234 1.607l.163-.093c-.326-.606-.512-1.723-.512-2.748V0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol